<table class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th>
        Customer {{ this._sortColumn === 'customer_first' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th>
        Customer Email {{ this._sortColumn === 'customer_email' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th>
        Amount {{ this._sortColumn === 'total_amount' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th>
        Transactions {{ this._sortColumn === 'transactions' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th>
        Description {{ this._sortColumn === 'description' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
    </tr>
  </thead>
  <tbody>
    @if (loading) {
      <tr>
        <td colspan="5">
          <div class="cpo-table-loading">
            <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
          </div>
        </td>
      </tr>
    } @else {
      @for (
        item of this.dataSource.data;
        track item.id;
        let even = $even;
        let odd = $odd;
      ) {
        @if (item.id != undefined) {
          <tr
            id="trsummary_{{ item.id }}"
            [ngClass]="{ even: even, odd: odd }"
            class="cpo-selectable-table__row selectable-row"
            (click)="onRowClick(item)"
          >
            <td>
              {{ item.customerFirst }} {{ item.customerLast }}
            </td>
            <td>
              {{ item.recipientEmail }}
            </td>
            <td>
              ${{ item.totalAmount }}
            </td>
            <td>
              {{ item.transactions }}
            </td>
            <td>
              {{ item.description }}
            </td>
          </tr>
        }
      }
    }
  </tbody>
</table>



<!-- <table class="selectableTable">
  <tr>
    <th>Customer</th>
    <th>Customer Email</th>
    <th>Total Amount</th>
    <th>Transactions</th>
    <th>Description</th>
  </tr>
  @for (
    item of this.dataSource.data;
    track item;
    let even = $even;
    let odd = $odd
  ) {
    @if (item.id != undefined) {
      <tr
        id="trsummary_{{ item.id }}"
        [ngClass]="{ even: even, odd: odd }"
        class="rowSummary highlightable"
        (click)="onRowClick(item)"
      >
        <td style="width: 15%">
          {{ item.customerFirst }} {{ item.customerLast }}
        </td>
        <td style="width: 15%">{{ item.recipientEmail }}</td>
        <td style="width: 15%">${{ item.totalAmount }}</td>
        <td style="width: 15%">{{ item.transactions }}</td>
        <td style="width: 15%">{{ item.description }}</td>
      </tr>
    }
  }
</table> -->
